import React, { useState, useEffect } from "react";
import * as Styled from "../../../CompanyForm.styled.js";
import * as MUIStyled from "../../../MUIStyled.js";
import CompanyDetailForm from "./CompanyDetailForm.js";
import { getCompanyDetail } from "../../../config/fetchAPI.js";
import { DefaultLayout } from "../../common/Layout/DefaultLayout.js";
import ProgressBarStepper from "../../elements/ProgressBar/ProgressBar.js";
import Loading from "../../elements/Loading/Loading.js";

const currentStep = 1;
const totalSteps = 6;

export const CompanyDetailPage = () => {
    const [companyDetails, setCompanyDetails] = useState([]);
    const [accountingSoftwareDropdown, setAccountingSoftwareDropdown] =
        useState([]);
    const [companyTypesDropdown, setCompanyTypesDropdown] = useState([]);
    const [companyEmployerMethodsDropdown, setCompanyEmployerMethodsDropdown] =
        useState([]);
    const [industriesDropdown, setIndustriesDropdown] = useState([]);
    const [payrollDaysOfMonthsDropdown, setPayrollDaysOfMonthsDropdown] =
        useState([]);
    const [payrollFrequenciesDropdown, setPayrollFrequenciesDropdown] =
        useState([]);

    const [open, setOpen] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    const associations = sessionStorage.getItem("associations");

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);

    const fetchData = async () => {
        try {
            const [companyDetailsResponse] = await Promise.all([
                getCompanyDetail(),
            ]);
            setCompanyDetails(companyDetailsResponse);

            setAccountingSoftwareDropdown(
                JSON.parse(associations).accountingSoftware
            );
            setCompanyTypesDropdown(JSON.parse(associations).companyTypes);
            setCompanyEmployerMethodsDropdown(
                JSON.parse(associations).companyEmployerMethods
            );
            setIndustriesDropdown(JSON.parse(associations).industries);
            setPayrollDaysOfMonthsDropdown(
                JSON.parse(associations).payrollDaysOfMonths
            );
            setPayrollFrequenciesDropdown(
                JSON.parse(associations).payrollFrequencies
            );
        } catch (err) {
            console.error("Error loading cached fields:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <DefaultLayout currentStep={currentStep}>
            {isLoading ? (
                <Loading />
            ) : (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <MUIStyled.CustomContainer>
                        <Styled.MainTitle style={{ margin: "40px 0 0 0" }}>
                            Company details
                        </Styled.MainTitle>

                        <CompanyDetailForm
                            onClose={handleClose}
                            open={open}
                            companyDetails={companyDetails}
                            accountingSoftwareDropdown={
                                accountingSoftwareDropdown
                            }
                            companyTypesDropdown={companyTypesDropdown}
                            companyEmployerMethodsDropdown={
                                companyEmployerMethodsDropdown
                            }
                            industriesDropdown={industriesDropdown}
                            payrollDaysOfMonthsDropdown={
                                payrollDaysOfMonthsDropdown
                            }
                            payrollFrequenciesDropdown={
                                payrollFrequenciesDropdown
                            }
                        />
                    </MUIStyled.CustomContainer>

                    <Styled.ProgressBarContainerWrapper>
                        {currentStep <= totalSteps && (
                            <ProgressBarStepper
                                currentStep={currentStep}
                                totalSteps={totalSteps}
                            />
                        )}
                    </Styled.ProgressBarContainerWrapper>
                </div>
            )}
        </DefaultLayout>
    );
};
